import { fetch } from "../network";
import { loanDetailsConfigs } from "./configs";
import { LoanDetailsSerializer } from "./serializer";

const serializer = LoanDetailsSerializer();

export const getOverview = async (id) => {
  const config = loanDetailsConfigs.get_overview;
  const endpoint = config.endpoint.replace("$id", id);
  return new Promise((resolve, reject) => {
    fetch(config.method, `${endpoint}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response));
  });
};

export const updateOverview = (body) => {
  const config = loanDetailsConfigs.update_overview;
  const endpoint = config.endpoint.replace("$id", body.id);
  return new Promise((resolve, reject) => {
    serializer
      .updateOverview(body)
      .then((serializedBody) => {
        fetch(config.method, `${endpoint}`, serializedBody)
          .then((response) => resolve(response.data))
          .catch((error) => reject(error.response));
      })
      .catch((error) => reject(error));
  });
};

export const getBorrower = (id) => {
  const config = loanDetailsConfigs.get_borrower;
  const endpoint = config.endpoint.replace("$id", id);
  return new Promise((resolve, reject) => {
    fetch(config.method, `${endpoint}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response));
  });
};

export const updateBorrower = (body) => {
  const config = loanDetailsConfigs.update_borrower;
  const endpoint = config.endpoint.replace("$id", body.opportunityId);
  delete body.opportunityId;
  return new Promise((resolve, reject) => {
    serializer
      .updateBorrower(body)
      .then((body) => {
        fetch(config.method, endpoint, body)
          .then((response) => resolve(response.data))
          .catch((error) => reject(error.response));
      })
      .catch((error) => reject(error));
  });
};

export const getAdditionalGuarantors = (id) => {
  const config = loanDetailsConfigs.get_additional_guarantors;
  const endpoint = config.endpoint.replace("$id", id);
  return new Promise((resolve, reject) => {
    fetch(config.method, `${endpoint}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response));
  });
};

export const updateAdditionalGuarantors = (body) => {
  const config = loanDetailsConfigs.update_additional_guarantors;
  const endpoint = config.endpoint.replace("$id", body.opportunityId);
  delete body.opportunityId;
  return new Promise((resolve, reject) => {
    serializer
      .updateAdditionalGuarantors(body)
      .then((body) => {
        fetch(config.method, endpoint, body)
          .then((response) => resolve(response.data))
          .catch((error) => reject(error.response));
      })
      .catch((error) => reject(error));
  });
};

export const getEquityStructure = (id) => {
  const config = loanDetailsConfigs.get_equity_structure;
  const endpoint = config.endpoint.replace("$id", id);
  return new Promise((resolve, reject) => {
    fetch(config.method, `${endpoint}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response));
  });
};

export const updateEquityStructure = (body) => {
  const config = loanDetailsConfigs.update_equity_structure;
  const endpoint = config.endpoint.replace("$id", body.id);
  return new Promise((resolve, reject) => {
    fetch(config.method, endpoint, body.equityList)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response));
  });
};

export const getAdditionalTeamMembers = (id) => {
  const config = loanDetailsConfigs.get_additional_team_members;
  const endpoint = config.endpoint.replace("$id", id);
  return new Promise((resolve, reject) => {
    fetch(config.method, `${endpoint}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response));
  });
};

export const updateAdditionalTeamMembers = (body) => {
  const config = loanDetailsConfigs.update_additional_team_members;
  const endpoint = config.endpoint.replace("$id", body.id);
  return new Promise((resolve, reject) => {
    fetch(config.method, endpoint, body.members)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response));
  });
};

export function LoanDetailsController() {
  return Object.freeze({
    getOverview,
    updateOverview,
    getBorrower,
    updateBorrower,
    getAdditionalGuarantors,
    updateAdditionalGuarantors,
    getEquityStructure,
    updateEquityStructure,
    getAdditionalTeamMembers,
    updateAdditionalTeamMembers,
  });
}
